module.exports = __webpack_public_path__ + "static/media/3_revista_vuelo-min.6972b1db.jpg";